import React from "react";
import { useTranslation } from "react-i18next";

const Amenities: React.FunctionComponent<{ private_amenities: any; shared_amenities: any }> = (props) => {

  const { t } = useTranslation();

  const privateAmenitiesArray = Array.isArray(props.private_amenities)
    ? props.private_amenities.filter(item => item.trim() !== '')
    : (props.private_amenities || '')
      .split(",")
      .map((amenity: any) => amenity.trim())
      .filter((amenity: any) => amenity !== '');

  const sharedAmenitiesArray = Array.isArray(props.shared_amenities)
    ? props.shared_amenities.filter(item => item.trim() !== '')
    : (props.shared_amenities || '')
      .split(",")
      .map((amenity: any) => amenity.trim())
      .filter((amenity: any) => amenity !== '');


  return (
    <>
      {privateAmenitiesArray.length > 0 && <h3 className="title-20 mb-4 color-black line-height-30">{t("generateDescTitle.privateAmenities")}</h3>}      <div className="mb-4">
        <div className="amenities-grid">
          {privateAmenitiesArray.length > 0 && privateAmenitiesArray.map((amenity: string, index: number) => (
            <div key={index} className="form-check mb-2">
              <input
                id={`check-${index}`}
                type="checkbox"
                className="form-check-input"
                name={`check-${index}`}
                checked={privateAmenitiesArray.includes(amenity)}
                readOnly
              />
              <label className="form-check-label" htmlFor={`check-${index}`}>{amenity}</label>
            </div>
          ))}
        </div>
      </div>

      {sharedAmenitiesArray.length > 0 && <h3 className="title-20 mb-4 color-black line-height-30">{t("generateDescTitle.sharedAmenities")}</h3>}
      <div className="mb-4">
        <div className="amenities-grid">
          {sharedAmenitiesArray.length > 0 && sharedAmenitiesArray.map((amenity: string, index: number) => (
            <div key={index} className="form-check mb-2">
              <input
                id={`check-${index}`}
                type="checkbox"
                className="form-check-input"
                name={`check-${index}`}
                checked={sharedAmenitiesArray.includes(amenity)}
                readOnly
              />
              <label className="form-check-label" htmlFor={`check-${index}`}>{amenity}</label>
            </div>
          ))}
        </div>

      </div>
    </>
  );
};

export default Amenities;
